// Money#label, character for character, in the browser: the reader's
// language writes it, and the server hands the coin over as Money.shape
// (docs/PAY.md § Money is a field). R$ 1.234,56 in pt, R$1,234.56 in en,
// R$ 1234,56 in es. Never Intl's currency style: es writes "BRL" there.
export function label(cents, { mark = '', pattern = '%n', places = 0, separator = '.', delimiter = '', grouping = 1 }) {
  const n = Number(places);
  // Integer math, never a float division: the remainder is exact below 2 ** 53,
  // so the last place of a big amount or a 3 and 8 place coin is the coin's.
  const abs = Math.abs(cents);
  const rest = abs % 10 ** n;
  const whole = String((abs - rest) / 10 ** n);
  const frac = n > 0 ? String(rest).padStart(n, '0') : '';
  const grouped = whole.length < 3 + Number(grouping) ? whole : whole.replace(/\B(?=(\d{3})+(?!\d))/g, delimiter);
  const number = grouped + (frac ? separator + frac : '');
  // Functions, not strings: a "$" in "R$" is a replacement pattern to String#replace.
  return `${cents < 0 ? '-' : ''}${pattern.replace('%u', () => mark).replace('%n', () => number)}`;
}
